import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-b75ffaca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "app-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "logo"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "压图", -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  class: "header-nav"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = {
  class: "page-content"
};
const _hoisted_9 = {
  key: 0,
  class: "page-title"
};
const _hoisted_10 = {
  class: "app-footer"
};
const _hoisted_11 = {
  class: "footer-content"
};
const _hoisted_12 = {
  class: "copyright"
};
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-links\" data-v-b75ffaca><a href=\"/\" class=\"footer-link\" data-v-b75ffaca>首页</a><span class=\"separator\" data-v-b75ffaca>|</span><a href=\"/ai.html\" class=\"footer-link\" data-v-b75ffaca>AI工具</a><span class=\"separator\" data-v-b75ffaca>|</span><a href=\"/batch.html\" class=\"footer-link\" data-v-b75ffaca>批量处理</a></div>", 1);
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-up"
}, null, -1));
const _hoisted_15 = [_hoisted_14];
import { computed, ref, onMounted, onUnmounted } from 'vue';
export default {
  __name: 'PageLayout',
  props: {
    title: {
      type: String,
      default: ''
    },
    currentPage: {
      type: String,
      default: ''
    },
    customLinks: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const skipHome = () => {
      window.location.href = '/';
    };

    // 默认导航链接
    const defaultLinks = [{
      url: '/',
      text: '返回主页'
    }, {
      url: '/ai.html',
      text: 'AI工具集'
    }, {
      url: '/batch.html',
      text: '批量图片压缩'
    }, {
      url: '/single.html',
      text: '单张图片压缩'
    }, {
      url: '/url.html',
      text: 'URL获取图像'
    }, {
      url: '/towcode.html',
      text: '二维码生成'
    }, {
      url: '/jsoncode.html',
      text: 'JSON格式化'
    }, {
      url: '/jsonstring.html',
      text: 'JSON转义'
    }, {
      url: '/timechange.html',
      text: '时间转换'
    }];

    // 合并用户自定义链接和默认链接，并排除当前页面
    const navLinks = computed(() => {
      let links = props.customLinks.length > 0 ? props.customLinks : defaultLinks;
      // 如果设置了当前页面，则从导航中排除当前页面的链接
      if (props.currentPage) {
        links = links.filter(link => !link.url.includes(props.currentPage));
      }
      return links;
    });

    // 回到顶部功能
    const showBackToTop = ref(false);
    const handleScroll = () => {
      showBackToTop.value = window.scrollY > 300;
    };
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", {
        class: "logo-container",
        onClick: skipHome
      }, _hoisted_5), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navLinks.value, link => {
        return _openBlock(), _createElementBlock("a", {
          key: link.url,
          href: link.url,
          class: "nav-link"
        }, _toDisplayString(link.text), 9, _hoisted_7);
      }), 128))])]), _createElementVNode("main", _hoisted_8, [__props.title ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")]), _createElementVNode("footer", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, "© " + _toDisplayString(new Date().getFullYear()) + " 压图 . 保留所有权利.", 1), _hoisted_13])]), _createElementVNode("div", {
        class: _normalizeClass(["back-to-top", {
          visible: showBackToTop.value
        }]),
        onClick: scrollToTop
      }, _hoisted_15, 2)]);
    };
  }
};